import React from 'react';
import PropTypes from 'prop-types';
import Project from './Project';

// 'https://blog.logrocket.com/wp-content/uploads/2021/09/5-react-performance-optimization-techniques.png'

const ProjectList = ({ className, list }) => (
  <ul
    className={`${className || ''} grid  md:grid-cols-2  xl:grid-cols-3 gap-5`}
  >
    {list.map((item, index) => (
      <li key={index}>
        <Project info={item} />
      </li>
    ))}
  </ul>
);

ProjectList.propTypes = {
  className: PropTypes.string,
  list: PropTypes.array,
};

export default ProjectList;
